import { Crypto, LocalStorage } from "./utils";
/**
 * A class for implementing Proof Key for Code Exchange operations
 */
var ProofKeyCodeEx = /** @class */ (function () {
    function ProofKeyCodeEx() {
    }
    var _a;
    _a = ProofKeyCodeEx;
    /**
     * Creates and stores the PKCE code verififer and code challenge
     * @returns The code verifier and code challenge
     */
    ProofKeyCodeEx.generateChallenge = function () {
        var codeVerifier = Crypto.createRandomString();
        var pkce = {
            codeVerifier: codeVerifier,
            codeChallenge: Crypto.base64UrlEncode(codeVerifier),
        };
        _a.storeChallenge(pkce);
        return pkce;
    };
    /**
     * Validates the PKCE challange
     * @param pkce - The object containng the code verififer and code challenge
     * @returns A boolean indicating whether the PKCE challenge is valid
     */
    ProofKeyCodeEx.isValidChallenge = function (pkce) {
        return Crypto.base64UrlEncode(pkce.codeVerifier) === pkce.codeChallenge;
    };
    /**
     * Stores the PKCE challange in local storage as a JSON string
     * @param pkce The object containng the code verififer and code challenge
     */
    ProofKeyCodeEx.storeChallenge = function (pkce) {
        LocalStorage.setItem("pkce", JSON.stringify(pkce));
    };
    /**
     * Gets the PKCE challenge from local storage
     * @returns The object containng the code verififer and code challenge
     */
    ProofKeyCodeEx.getChallengeFromStorage = function () {
        return JSON.parse(LocalStorage.getItem("pkce"));
    };
    return ProofKeyCodeEx;
}());
export { ProofKeyCodeEx };
